<template lang="html">
  <div class="activityPage ">
  	<common-header></common-header>
    <list-kv :kvArray="kvItems"></list-kv>
    <activity :tabArr="activityTabArr" :activityAllArr="activityArr"></activity>
    <common-footer></common-footer>
  </div>
</template>

<script>
	//组件
	import commonHeader from '../../components/common/commonHeader'
	import commonFooter from '../../components/common/commonFooter'
	import listKv from '../../components/common/listKv'
	import activity from'../../components/activity/activity.vue'
	//接口
	import Server from '../../server/server.js'
	export default {
	  	data(){
		  	return{
		  		kvItems:[],
		  		activityTabArr:[],
		  		typeCode:['9902001','9902002','9902003','9902004','9902005'],//资讯栏目号，分别为会员公益活动、鸿鹄投资课、君弘财富万里行、千里马培训课
		  		startIndex:0,
		  		endIndex:3,
		  		activityArr:[],
		  	}
	  	},
	  	components:{
	  		commonHeader,
	  		commonFooter,
	  		listKv,
	  		activity
	  	}, 
	  	methods:{
	  		getActivityList:function(){
	  			for(var i=0; i< this.typeCode.length;i++){
		  			Server.listInfo(this.startIndex,this.endIndex,this.typeCode[i]).then((result)=>{
			  			if(result.code == '0'){
			  				this.activityArr.push(result.msg.infos);
			  				let list = result.msg.infos
			  				this.activityTabArr.push(list[0]['TYPE_NAME']);
			  			}
			  		})
		  		}
		  		console.log(this.activityArr);
		  		
	  		},
	  	},
	  	created(){
	  		//KV 数据
	  		Server.listConfig('activityBanner').then((result)=>{
	  			if(result.code == '0'){
	  				this.kvItems = result.msg.types;
	  			}
	  		})
	  		//获取各个栏目的前四篇资讯
	  		this.getActivityList();
	  	},
	}
</script>

<style lang="less" scoped>

	.activityPage{
		// padding-bottom:200px;
	}
</style>


// WEBPACK FOOTER //
// src/container/activityPage/activity.vue